import { useAccount } from 'wagmi'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import { useUpdaterChainId } from '~/hooks'
import { getXLonBalance } from '~/apis'
import {
  StyledStakingFooter,
  StyledStakingContainer,
  StyledFooterButton,
} from './styled'
import { IFooterButtonProps, IStakingFooterProps } from './types'

const FooterButton = ({
  children,
  primary,
  inline,
  ...props
}: IFooterButtonProps) => {
  const primaryStyle = primary ? 'primary' : ''
  const inlineStyle = inline ? 'inline' : ''
  return (
    <>
      <StyledFooterButton
        className={`${primaryStyle} ${inlineStyle}`}
        {...props}
      >
        {children}
      </StyledFooterButton>
    </>
  )
}

const StakingFooter = ({ onRedeem }: IStakingFooterProps) => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const chainId = useUpdaterChainId()

  const { data: xLonBalance } = useSWR(
    ['getXLonBalance', chainId, account],
    () => getXLonBalance(chainId, account),
  )

  if (!account) return null

  return (
    <StyledStakingFooter>
      <StyledStakingContainer>
        {account && Number(xLonBalance) > 0 && (
          <FooterButton key="redeem" onClick={onRedeem}>
            {t('redeem')}
          </FooterButton>
        )}
      </StyledStakingContainer>
    </StyledStakingFooter>
  )
}

export default StakingFooter
